import { render } from "./Bienvenido.vue?vue&type=template&id=54d58218"
import script from "./Bienvenido.vue?vue&type=script&lang=js"
export * from "./Bienvenido.vue?vue&type=script&lang=js"
script.render = render

export default script